export const speedLevelList = ['ด่วนที่สุด', 'ด่วนมาก', 'ด่วน', 'ปกติ']

export const secretLevelList = ['ปกติ', 'ลับ', 'ลับมาก', 'ลับที่สุด']


// WEBPACK FOOTER //
// ./src/utils/documentType.js